/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminProjectUserData } from './AdminProjectUserData';
import {
    AdminProjectUserDataFromJSON,
    AdminProjectUserDataFromJSONTyped,
    AdminProjectUserDataToJSON,
    AdminProjectUserDataToJSONTyped,
} from './AdminProjectUserData';

/**
 * 
 * @export
 * @interface AdminProjectRowData
 */
export interface AdminProjectRowData {
    /**
     * 
     * @type {string}
     * @memberof AdminProjectRowData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProjectRowData
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof AdminProjectRowData
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof AdminProjectRowData
     */
    subscriptionPackageName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminProjectRowData
     */
    subscriptionStatus?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminProjectRowData
     */
    isTrial?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof AdminProjectRowData
     */
    subscriptionEndsAt?: Date | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminProjectRowData
     */
    activeIntegrations?: Array<string>;
    /**
     * 
     * @type {Array<AdminProjectUserData>}
     * @memberof AdminProjectRowData
     */
    users?: Array<AdminProjectUserData>;
}

/**
 * Check if a given object implements the AdminProjectRowData interface.
 */
export function instanceOfAdminProjectRowData(value: object): value is AdminProjectRowData {
    return true;
}

export function AdminProjectRowDataFromJSON(json: any): AdminProjectRowData {
    return AdminProjectRowDataFromJSONTyped(json, false);
}

export function AdminProjectRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProjectRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'subscriptionPackageName': json['subscriptionPackageName'] === undefined ? undefined : json['subscriptionPackageName'] === null ? null : json['subscriptionPackageName'],
        'subscriptionStatus': json['subscriptionStatus'] === undefined ? undefined : json['subscriptionStatus'] === null ? null : json['subscriptionStatus'],
        'isTrial': json['isTrial'] == null ? undefined : json['isTrial'],
        'subscriptionEndsAt': json['subscriptionEndsAt'] === undefined ? undefined : json['subscriptionEndsAt'] === null ? null : (new Date(json['subscriptionEndsAt'])),
        'activeIntegrations': json['activeIntegrations'] == null ? undefined : json['activeIntegrations'],
        'users': json['users'] == null ? undefined : ((json['users'] as Array<any>).map(AdminProjectUserDataFromJSON)),
    };
}

export function AdminProjectRowDataToJSON(json: any): AdminProjectRowData {
    return AdminProjectRowDataToJSONTyped(json, false);
}

export function AdminProjectRowDataToJSONTyped(value?: AdminProjectRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'subscriptionPackageName': value['subscriptionPackageName'],
        'subscriptionStatus': value['subscriptionStatus'],
        'isTrial': value['isTrial'],
        'subscriptionEndsAt': value['subscriptionEndsAt'] == null ? value['subscriptionEndsAt'] : value['subscriptionEndsAt'].toISOString(),
        'activeIntegrations': value['activeIntegrations'],
        'users': value['users'] == null ? undefined : ((value['users'] as Array<any>).map(AdminProjectUserDataToJSON)),
    };
}

